import React from 'react';
import { motion } from 'framer-motion';

const ExcerptNoteRo = () => (
  <section className="py-16 bg-brand-dark border-t border-white/5">
    <div className="max-w-3xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="bg-brand-surface border border-white/8 rounded-2xl p-8 md:p-10 relative overflow-hidden"
      >
        <div className="absolute top-0 left-0 w-1 h-full bg-brand-accent rounded-l-2xl"></div>
        <p className="text-brand-accent font-semibold text-xs uppercase tracking-widest mb-5 pl-2">
          O Notă despre Ceea Ce Ești pe Cale să Citești
        </p>
        <div className="space-y-4 pl-2">
          <p className="text-gray-300 leading-relaxed">
            <em>Trezirea Cuantică</em> nu se deschide cu acțiune, ci cu un moment: prima pâlpâire de
            coerență auto-organizată într-un procesor cuantic, observată de o femeie pe nume{' '}
            <span className="text-white font-medium">Elena Vasquez</span>, care nu înțelege încă ce a
            creat.
          </p>
          <p className="text-gray-400 leading-relaxed">
            Cartea cuprinde cinci secole și opt lumi. Urmărește patru linii familiale de-a lungul
            generațiilor. Cronichează terraformarea Venusului, colonizarea Tritonului, descoperirea
            vieții pe Europa și lansarea primei nave interstelar cu echipaj a umanității. Dar fiecare
            pagină a acelei vaste povești conduce înapoi la această cameră, această dimineață, această
            femeie care{' '}
            <span className="text-white">a continuat să lucreze când toți ceilalți renunțaseră.</span>
          </p>
          <p className="text-gray-500 text-sm leading-relaxed italic">
            Fragmentul de mai jos este extras din deschiderea Capitolului Unu.
          </p>
        </div>
      </motion.div>
    </div>
  </section>
);

export default ExcerptNoteRo;